import isNotAuth from '@/router/middleware/isNotAuth'
import isAuth from '@/router/middleware/isAuth'
import notFound from '@/router/middleware/notFound'

import { ROUTES } from '@/constants/routes'

export const BASE_ROUTES = [
    {
        path: '/login',
        name: ROUTES.login,
        meta: {
            layout: 'empty',
            middleware: isNotAuth,
            title: 'DVoice Admin Login',
            reference: ROUTES.login,
        },
        component: () => import('@/views/auth/Auth.vue'),
    }, {
        path: '/call-log',
        name: ROUTES.callLog,
        meta: {
            layout: 'main',
            middleware: isAuth,
            reference: ROUTES.callLog,
        },
        component: () => import('@/views/call-log/CallLog.vue'),
    }, {
        path: '/call-log/:slug',
        name: ROUTES.detailCallLog,
        meta: {
            layout: 'main',
            middleware: isAuth,
            reference: ROUTES.callLog,
        },
        component: () => import('@/views/call-log/DetailCallLog.vue'),
    }, {
        path: '/whitelist',
        name: ROUTES.whitelist,
        meta: {
            layout: 'main',
            middleware: isAuth,
            reference: ROUTES.whitelist,
        },
        component: () => import('@/views/whitelist/Whitelist.vue'),
    }, {
        path: '/url-binding',
        name: ROUTES.urlBinding,
        meta: {
            layout: 'main',
            middleware: isAuth,
            reference: ROUTES.urlBinding,
        },
        component: () => import('@/views/url-binding/UrlBinding.vue'),
    }, {
        path: '/trunks',
        name: ROUTES.trunks,
        meta: {
            layout: 'main',
            middleware: isAuth,
            reference: ROUTES.trunks,
        },
        component: () => import('@/views/trunks/Trunks.vue'),
    }, {
        path: '/:pathMatch(.*)*',
        name: ROUTES.notFound,
        meta: {
            layout: 'empty',
            middleware: notFound,
            reference: ROUTES.notFound,
        },
        component: () => import('@/views/NotFound.vue'),
    },
]
